/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EmailRecipientDto
 */
export interface EmailRecipientDto {
    /**
     * Recipient email address
     * @type {string}
     * @memberof EmailRecipientDto
     */
    to: string;
    /**
     * Recipient name
     * @type {string}
     * @memberof EmailRecipientDto
     */
    name: string;
}

/**
 * Check if a given object implements the EmailRecipientDto interface.
 */
export function instanceOfEmailRecipientDto(value: object): value is EmailRecipientDto {
    if (!('to' in value) || value['to'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function EmailRecipientDtoFromJSON(json: any): EmailRecipientDto {
    return EmailRecipientDtoFromJSONTyped(json, false);
}

export function EmailRecipientDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmailRecipientDto {
    if (json == null) {
        return json;
    }
    return {
        
        'to': json['to'],
        'name': json['name'],
    };
}

export function EmailRecipientDtoToJSON(json: any): EmailRecipientDto {
    return EmailRecipientDtoToJSONTyped(json, false);
}

export function EmailRecipientDtoToJSONTyped(value?: EmailRecipientDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'to': value['to'],
        'name': value['name'],
    };
}

